import { CSS } from '@stitches/react';
import { ChangeEvent, ReactNode } from 'react';

type RadioValue = string | number;

export enum RadioGroupDirection {
  ROW = 'row',
  ROWS = 'rows',
  COLUMN = 'column',
}

export interface RadioGroupProps {
  css?: CSS;
  children: ReactNode;
  defaultValue?: RadioValue;
  direction?: RadioGroupDirection;
  disabled?: boolean;
  id: string;
  label?: string;
  labelStyles?: CSS;
  name: string;
  onChange?: (event: ChangeEvent<HTMLInputElement>, value: RadioValue) => void;
  reset?: boolean;
}
